import { useQuery } from '@tanstack/react-query';
import { api } from '../../../singleton/axios';

interface ManualHolding {
  ticker: string;
  shares: number;
  averagePrice: number;
}

interface ManualHoldingsResponse {
  holdings: ManualHolding[];
}

async function fetchManualHoldings(): Promise<ManualHoldingsResponse> {
  const { data } = await api.get<ManualHoldingsResponse>('/portfolio/manual-holdings');
  return data;
}

export function useManualHoldings(enabled = true) {
  return useQuery<ManualHoldingsResponse, Error>({
    queryKey: ['portfolio', 'manual-holdings'],
    queryFn: fetchManualHoldings,
    enabled,
    staleTime: 1 * 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
}

export type { ManualHolding, ManualHoldingsResponse };